import Hero from "../components/LandingPage/Hero";
import Features from "../components/LandingPage/Features";
import Miss from  "../components/LandingPage/Miss";
import Cta from  "../components/LandingPage/Cta";

export default function LandingPage (){
  return (

  <> 
    <Hero/> 
    <Features/>
    <Miss/>
    <Cta/>
  </>

 )
}
